export enum CrmErrorsConst {
  ACTIVE_CREDIT_REQUEST = 'Operation error, client has active credit request',
  EXPIRED_PASSPORT = 'Passport issue date happened before min possible age'
}
